import styled from "styled-components";

// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const STYLES = {
    contentPaddingRight: 36,
    dividerHeight: 1,
};

export const Container = styled.div(({ theme }) => ({
    overflow: "hidden",
    padding: `${theme.spacing.medium} ${theme.spacing.medium} 0 ${theme.spacing.medium}`,
}));

export const AutoPaymentMethodContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
`;

export const DisplayNameContainer = styled.div`
    display: flex;
`;

export const PrimaryContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - ${STYLES.contentPaddingRight}px);
`;

export const PaymentMethodSlideButtonContainer = styled.div(({ theme }) => ({
    marginLeft: 0,
    marginTop: `${theme.spacing.medium}`,
}));

export const Separator = styled.div(({ theme }) => ({
    height: `${STYLES.dividerHeight}px`,
    backgroundColor: `${theme.colors.light.border_Tertiary}`,
    margin: `${theme.spacing.xxSmall} 0 ${theme.spacing.xSmall}`,
}));

export const TitleContainer = styled(Text)`
    padding-bottom: ${props => props.theme.spacing.xxxSmall};
    text-transform: uppercase;
`;
